// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7667a689","952":"d75588b9"}[chunkId] + ".chunk.js";
};